import React from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { indexOf } from 'lodash';

function DefaultTeamRenderer(props) {
  const {
    data, value, updatingTeams,
  } = props;
  if (data && data._id) {
    const editing = indexOf(updatingTeams, data._id) >= 0;

    
    const tip = (
      <Tooltip id={`default-team-${data._id}`}>
        <span>Default Team</span>
      </Tooltip>
    );
    let name = value === true ? 'star' : 'star-o';
    let cls = value === true ? 'text-warning' : 'text-muted';
    if (editing) {
      name = 'spinner';
      cls = 'text-muted';
    }

    const comp = (<Fa name={name} className={cls} spin={editing} />);
    
    let displayComp = comp;
    if (value === true) {
      displayComp = (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          {comp}
        </OverlayTrigger>
      );
    } else {
      displayComp = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            props.requestUpdateTeam(data);
          }}
        >
          {comp}
        </a>
      );
    }

    return (
      <div className="text-center">
        {displayComp}
      </div>
    );
  }
  return null;
}
DefaultTeamRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
  value: PropTypes.bool,
  requestUpdateTeam: PropTypes.func,
  deletingTeams: PropTypes.arrayOf(PropTypes.string),
  updatingTeams: PropTypes.arrayOf(PropTypes.string),
};
DefaultTeamRenderer.defaultProps = {
  requestUpdateTeam: () => {},
  data: null,
  value: false,
  updatingTeams: [],
  deletingTeams: [],
};
export default DefaultTeamRenderer;
